enum SplitNames {
  CELEBRATION_BOTS = 'CELEBRATION_BOTS',
  SlugUrl = 'SLUG_URL',
  Search = 'SEARCH',
  NewTemplateGallery = 'TEMPLATE_GALLERY',
  DisplayAppBanner = 'DISPLAY_APP_BANNER',
  DisplayQRCode = 'DISPLAY_QR_CODE',
  PresetTemplateGalleryFilters = 'PRESET_TEMPLATE_GALLERY_FILTERS',
  SlackShareSheetIntegration = 'SLACK_SHARESHEET_INTEGRATION',
  SimplifiedShareSheet = 'SHARESHEET_V2',
  PreloadedFlowUpdates = 'PRELOADED_FLOW_UPDATES',
  NPSBlock = 'NPS_BLOCK',
  DataDogRecording = 'ENABLE_DATADOG_RECORDING',
}

enum TreatmentTypes {
  CONTROL = 'control',
  ON = 'on',
  OFF = 'off',
  NOT_YET_SET = 'NOT_YET_SET',
}

export { SplitNames, TreatmentTypes };
